<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopicid: '',
        tipopicdescricao: '',
        tipopicinformavalorbrutoliquido: '',
        tipopictipocontrole: '',
      }),
      require: true,
    },
    tabprecoid: {
      type: String,
      default: null,
      require: false,
    },
    picsituacao: {
      type: String,
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiitem: null,
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isDisabled() {
      return ['Aprovada', 'Pendente'].includes(this.picsituacao);
    },
    totalMercadoria() {
      // Calcula o valor total da mercadoria (quantidade * valor unitário)
      return (this.dataForm.picitemquantidade * this.dataForm.picitemvalorpic).toFixed(2);
    },
    isValorPicDisabled() {
      return this.isDisabled || (this.dataForm.picitemporcentagem !== 0 && this.dataForm.picitemporcentagem !== null);
    },
    isPorcentagemDisabled() {
      return this.isDisabled || (this.dataForm.picitemvalorpic !== 0 && this.dataForm.picitemvalorpic !== null);
    },
  },
  watch: {
    totalMercadoria(newValue) {
      this.dataForm.picitemtotalmercadoria = newValue;
    },
  },
  formatCurrency(value) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  },
  mounted() {
    this.fetchDataFromitem();
  },
  methods: {
    async validateForm() {
      console.log('PIC ITEM EDITADO', this.dataForm);
      this.dataForm.picitemquantidadesaldo = this.dataForm.picitemquantidade;
      try {
        const response = await axios.post('/pic-item/update', this.dataForm);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso!',
            text: `${response.data.message}`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        });

        this.$bvModal.hide(this.idModal);
        this.$emit('ok');
        this.$emit('refresh-table');
        this.$emit('cancel');
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            text: 'Ocorreu um erro ao atualizar o item',
            icon: 'AlertCircleIcon',
            variant: 'error',
          },
        });
      }
    },
    toUpperCase() {
      this.dataForm.tipopicid = this.dataForm.tipopicid.toUpperCase();
    },
    async fetchDataFromitem() {
      try {
        const response = await axios.get('/tabela-preco-item/findAllById');
        this.dataFromApiitem = response.data.data.map((item) => ({
          value: item.item && item.item.item_id, // Verifica se item.item existe antes de acessar item_id
          text: item.item && item.item.item_descricao, // Verifica se item.item existe antes de acessar item_descricao
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
};
</script>

<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="xl" :id="idModal" :title="titleModal"
    :ok-disabled="dataForm.isDefault || dataForm.tipopicdescricao === ''" :ok-title="labelBtnOk" ok-variant="success"
    cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok="validateForm"
    @cancel="$emit('cancel')" @close="$emit('cancel')">
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Item" label-for="itemid">
              <validation-provider #default="{ errors }" name="Descrição" rules="required">
                <b-form-select v-model="dataForm.itemid" id="itemid" :state="errors.length > 0 ? false : null"
                  :options="dataFromApiitem" value-field="value" text-field="text" placeholder="Digite a descrição"
                  disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--          <b-col-->
          <!--              cols="4"-->
          <!--              class="mb-1"-->
          <!--          >-->
          <!--            <b-form-group-->
          <!--                label="Sequencia"-->
          <!--                label-for="picitemsequencia"-->
          <!--            >-->
          <!--              <validation-provider-->
          <!--                  #default="{ errors }"-->
          <!--                  name="Descrição"-->
          <!--                  rules="required"-->
          <!--              >-->
          <!--                <b-form-input-->
          <!--                    v-model="dataForm.picitemsequencia"-->
          <!--                    id="picitemsequencia"-->
          <!--                    :state="errors.length > 0 ? false : null"-->
          <!--                    placeholder="Digite a sequencia"-->
          <!--                    :disabled="isDisabled"-->
          <!--                />-->
          <!--                <small class="text-danger">{{ errors[0] }}</small>-->
          <!--              </validation-provider>-->
          <!--            </b-form-group>-->
          <!--          </b-col>-->
          <b-col cols="4" class="mb-1">
            <b-form-group label="Quantidade" label-for="Quantidade">
              <validation-provider #default="{ errors }" name="picitemquantidade" rules="required">
                <b-form-input v-model="dataForm.picitemquantidade" id="picitemquantidade"
                  :state="errors.length > 0 ? false : null" :disabled="isDisabled" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Saldo" label-for="Saldo">
              <validation-provider #default="{ errors }" name="picitemquantidadesaldo" rules="required">
                <b-form-input v-model="dataForm.picitemquantidade" id="picitemquantidadesaldo"
                  :state="errors.length > 0 ? false : null" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Valor Unitario" label-for="Valor Unitario">
              <validation-provider #default="{ errors }" name="picitemvalorpic" rules="required">
                <b-form-input v-model="dataForm.picitemvalorpic" id="picterminovalidpicitemvalorpicade"
                  :state="errors.length > 0 ? false : null" :disabled="isValorPicDisabled" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Porcentagem Desconto" label-for="Porcentagem Desconto">
              <validation-provider #default="{ errors }" name="picitemporcentagem" rules="required">
                <b-form-input v-model="dataForm.picitemporcentagem" id="picitemporcentagem"
                  :state="errors.length > 0 ? false : null" :disabled="isPorcentagemDisabled" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="4" class="mb-1">
            <b-form-group label="Total Mercadoria" label-for="Total Mercadoria">
              <validation-provider #default="{ errors }" name="pictotalmercadoria" rules="required">
                <b-form-input v-model="totalMercadoria" id="pictotalmercadoria"
                  :state="errors.length > 0 ? false : null" disabled />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!--          <b-col-->
          <!--              cols="4"-->
          <!--              class="mb-1"-->
          <!--          >-->
          <!--            <b-form-group-->
          <!--                label="Situação"-->
          <!--                label-for="picitemsituacao"-->
          <!--            >-->
          <!--              <validation-provider-->
          <!--                  #default="{ errors }"-->
          <!--                  name="picitemsituacao"-->
          <!--                  rules="required"-->
          <!--              >-->
          <!--                <b-form-input-->
          <!--                    v-model="dataForm.picitemsituacao"-->
          <!--                    id="picitemsituacao"-->
          <!--                    :state="errors.length > 0 ? false : null"-->
          <!--                    :disabled="isDisabled"-->
          <!--                />-->
          <!--                <small class="text-danger">{{ errors[0] }}</small>-->
          <!--              </validation-provider>-->
          <!--            </b-form-group>-->
          <!--          </b-col>-->
        </b-row>
      </b-form>
    </validation-observer>

  </b-modal>
</template>
